import React from "react";
import { View, StyleSheet } from "react-native";
import { CompanionThreadsProvider } from "../contexts/CompanionThreadsContext";
import WorkspaceSidebarContainer from "../containers/companion/WorkspaceSidebarContainer";

function CompanionLayout({ children }) {
  return (
    <CompanionThreadsProvider>
      <View style={[styles.container, { flexDirection: "column" }]}>
        <View style={styles.content}>
          <WorkspaceSidebarContainer />
          <View style={styles.childrenWrapper}>{children}</View>
        </View>
      </View>
    </CompanionThreadsProvider>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    // @ts-expect-error - works on web
    maxHeight: "100vh",
    overflow: "hidden",
    position: "relative",
    zIndex: 1,
  },
  content: {
    flex: 1,
    flexDirection: "row",
    position: "relative",
    zIndex: 1,
  },
  childrenWrapper: {
    flex: 1,
    position: "relative",
    zIndex: 1,
  },
});

export default CompanionLayout;
